<template>
  <div class="page-businesses">
     <router-link to="/" class="btn-back"><span>Back to Dashboard</span></router-link>
    <h1 class="h2 mb-3">My Businesses</h1>
    <div class="row">
      <div class="col">
        <b-table class="mt-3" striped hover :items="items" :fields="fields">
          <template v-slot:cell(Name)="data">
            <router-link :to="`/business/${data.item.Id}`">{{ data.value }}</router-link>
          </template>
          <template v-slot:cell(actions)="data">
            <span v-if="data.item.canEdit">
              <router-link :to="`/business/${data.item.Id}/edit`" style="margin-left: 10px;"><b-icon-pencil /> Edit</router-link>&nbsp; | &nbsp;
            </span>
            <router-link :to="`/business/${data.item.Id}`" style="margin-left: 10px;"><b-icon-file-earmark-text /> View</router-link>&nbsp; | &nbsp;
           <router-link :to="`/membership-card/${data.item.Id}`" style="margin-left: 10px;"><b-icon-card-text /> Discount Card</router-link>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

axios.defaults.withCredentials = true;
const server = process.env.VUE_APP_API_URL;

export default {
  name: 'Businesses',
  data() {
    return {
      test: 'test',
      items: [],
      fields: [
        {
          key: 'Name',
          label: 'Business Name',
          sortable: true,
        },
        { key: 'actions', label: '' },
      ],
    };
  },
  mounted() {
    this.$nextTick(async () => {
      try {
        const rawItems = await axios.get(`${server}/api/accounts`);
        if (rawItems.data.redirect) {
          window.location.href = rawItems.data.redirect;
          return;
        }
        console.log(rawItems.data);
        this.items = rawItems.data.map((l) => ({
          Id: l.Id || l.Account.Id,
          Name: l.Name || l.Account.Name,
          canEdit: l.Roles.includes('Organization Administrator') || l.Roles.includes('Corporate Administrator'),
        }));
      } catch (err) {
        console.log({ listListingsError: err });
      }
    });
  },
};
</script>
